export enum OfferTransportKind {
	PLANE = 'F',
	COACH = 'C',
	BOTH = 'B',
}
